import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ICandidateAbandonApplicationNotification } from '@candidate/app/models/app-notification.model'
import { INotificationHandler, INotificationView, UserAppNotificationService } from '@engineering11/notifications-web'

@Injectable({ providedIn: 'root' })
export class CandidateAbandonApplicationSubmissionHandler
  implements INotificationHandler<ICandidateAbandonApplicationNotification, INotificationView>
{
  notificationType: string = 'candidate_abandon_application_submission'
  constructor(private router: Router, private userAppNotificationService: UserAppNotificationService) {}

  onClick(notification: ICandidateAbandonApplicationNotification): boolean | Promise<boolean> {
    if (!notification.viewed) {
      this.userAppNotificationService.markNotificationAsRead(notification.id)
    }
    this.router.navigate([`/applications/apply/${notification.jobPostId}`])
    return true
  }
}
